module.exports = __webpack_public_path__ + "static/media/Store Remarks.b8898d98.jpg";